import React from 'react';

// Importing icons from MUI material icons
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DeleteIcon from '@mui/icons-material/Delete';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import PeoplesAlt from '@mui/icons-material/PeopleAlt';
import ConfirmationNumber from '@mui/icons-material/ConfirmationNumber';
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FlagIcon from '@mui/icons-material/Flag';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import Warning from '@mui/icons-material/WarningRounded';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// Exporting the icons
export const LocationIcon = (props) => <LocationOnIcon {...props} />;
export const AddIcon = (props) => <AddCircleOutlineIcon {...props} />;
export const HighlightIcon = (props) => <HighlightOffIcon {...props} />;
export const DeleteIcons = (props) => <DeleteIcon {...props} />;
export const RupeesIcon = (props) => <CurrencyRupeeIcon {...props} />;
export const MinusIcon = (props) => <RemoveCircleOutlineIcon {...props} />;
export const EditIcons = (props) => <EditIcon {...props} />;
export const PeoplesIcon = (props) => <PeoplesAlt {...props} />;
export const TicketIcon = (props) => <ConfirmationNumber {...props} />;
export const SettingIcon = (props) => <SettingsIcon {...props} />;
export const CheckIcons = (props) => <CheckCircleIcon {...props} />;
export const Check = (props) => <CheckIcon {...props} />;
export const MaterialShareIcon = (props) => <ShareIcon {...props} />;
export const LikeIcon = (props) => <FavoriteIcon {...props} />;
export const ReportIcon = (props) => <FlagIcon {...props} />;
export const LikeBorderIcon = (props) => <FavoriteBorderIcon {...props} />;
export const AddCounterValue = (props) => <Add {...props} />;
export const RemoveCounterValue = (props) => <Remove {...props} />;
export const WarningIcon = (props) => <Warning {...props} />;
export const DotIcon = (props) => <FiberManualRecordIcon {...props} />;
